import { createSelector } from 'reselect'

export const stateSelector = state => state.api.get.all.meetings

export const data = () =>
  createSelector(
    [stateSelector],
    meetingsState => meetingsState.data
  )

export const isLoading = () =>
  createSelector(
    [stateSelector],
    meetingsState => meetingsState.isLoading
  )
